import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { resetFilter } from 'redux/actions/newFilter';
import TransactionDetail from './TransactionDetail.page';
import {
  getAccountDetail,
  getAccountTrx,
} from '../../redux/actions/transactions';

const mapStateToProps = state => ({
  loading: state.gold.loading,
  data: state.gold.accountDetail,
  loadingTrx: state.gold.loadingTrx,
  trxHistoryList: state.gold.trxHistoryList,
  trxHistoryFilter: state.gold.trxHistoryFilter,
  filterValue: state.newFilter.filterValue,
});

const mapDispatchToProps = {
  getAccountDetail,
  getAccountTrx,
  resetFilter,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(TransactionDetail));
